import { MA_APP_IDS } from '@wix/members-area-app-definitions';
import { LifecycleEvent, MEMBERS_AREA_APP_DEF_ID } from '../../constants';
import { emitEvent } from '../events';
import { addApplications, getMembersAPI, isSocialVertical, } from '../membersApi';
import { isAdi } from './utils';
const { IntegratedAppsInstallStart, IntegratedAppsInstallFinish, IntegrationFinish, } = LifecycleEvent;
export const appInstalled = async (appState, payload) => {
    const verticalAppDefId = appState.getAppDefinitionId();
    if (payload.appDefinitionId &&
        [MEMBERS_AREA_APP_DEF_ID, verticalAppDefId].includes(payload.appDefinitionId)) {
        const membersAPI = await getMembersAPI(appState.getEditorSDK());
        if (!membersAPI) {
            return;
        }
        const { installAppsAutomatically, membersAreaApps, membersAreaAppsOptions, installAutomatically, onEvent, } = appState.getIntegrationOptions();
        const options = appState.getEditorReadyOptions();
        const wasMembersAreaInstalledInitially = appState.getWasMembersAreaInstalledInitially();
        await membersAPI.registerMembersAreaApps(membersAreaApps, verticalAppDefId, membersAreaAppsOptions);
        if (installAppsAutomatically ||
            (payload.appDefinitionId === verticalAppDefId &&
                !wasMembersAreaInstalledInitially) ||
            isAdi(options)) {
            const triggeredBy = payload.appDefinitionId;
            emitEvent({
                event: IntegratedAppsInstallStart,
                payload: { triggeredBy },
                onEvent,
            });
            await membersAPI.installRegisteredApps(verticalAppDefId);
            emitEvent({
                event: IntegratedAppsInstallFinish,
                payload: { triggeredBy },
                onEvent,
            });
        }
        else if (isSocialVertical(verticalAppDefId)) {
            const alwaysInstalledSocialApps = [
                MA_APP_IDS.ABOUT,
                MA_APP_IDS.SETTINGS,
                MA_APP_IDS.NOTIFICATIONS,
            ].filter((app) => membersAreaApps.includes(app));
            await addApplications(appState.getEditorSDK(), alwaysInstalledSocialApps);
        }
        if (payload.appDefinitionId === verticalAppDefId && installAutomatically) {
            emitEvent({
                event: IntegrationFinish,
                payload: { firstInstall: options?.firstInstall },
                onEvent,
            });
        }
    }
};
//# sourceMappingURL=exportsEditorAPI.js.map